import { defineMessages } from 'react-intl';

export default defineMessages({
    agencyOfServiceDefaultValue: {
        id: 'quoteandbind.cl.account.policyHolder.agencyOfServiceDefaultValue',
        defaultMessage: '-- Required for Quote --',
    },
});